import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignParaQuienProps {
  sign: Sign;
}
export function SignParaQuien({
  sign
}: SignParaQuienProps) {
  return <section className="relative py-24 md:py-32 px-4 md:px-6 bg-cosmic-black" data-id="element-941">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-942">
        <AnimatedSection data-id="element-943">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-6" style={{
          textShadow: `0 0 30px ${sign.colors.primary}40`
        }} data-id="element-944">
            ¿Para Quién Es Esta Experiencia?
          </h2>
          <p className="text-lg md:text-xl font-serif italic mb-12" style={{
          color: sign.colors.accent
        }} data-id="element-945">
            Esta experiencia fue creada para personas que:
          </p>
        </AnimatedSection>

        <div className="flex flex-col gap-5 text-left" data-id="element-946">
          {sign.content.paraQuienItems.map((item, i) => <AnimatedSection key={i} delay={0.1 + i * 0.05} data-id="element-947">
              <div className="flex items-start gap-4" data-id="element-948">
                <div className="mt-2 w-2 h-2 rotate-45 flex-shrink-0" style={{
              backgroundColor: sign.colors.primary,
              boxShadow: `0 0 10px ${sign.colors.primary}`
            }} data-id="element-949" />
                <p className="text-base md:text-lg font-serif leading-relaxed" style={{
              color: '#F5F0E1'
            }} data-id="element-950">
                  {item}
                </p>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}